module.exports = __webpack_public_path__ + "static/media/add-lecture.40da1d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/add-lecture.png
// module id = 1928
// module chunks = 6